export const en = {
    languages: {
        finland: "Finnish",
        sweden: "Swedish",
        england: "English",
        germany: "Germany",
    },
    rowStatus: {
        new: "New",
        pending: "Pending",
        error: "Error",
        active: "Active",
        null: ""
    },
    common: {
        suppliers: "Suppliers",
        letters: "Letters",
        logout: "Log out",
        servicedesk: "Customer service",
        tos: "Terms of service",
        back: "Back",
    },
    login: {
        title: "ReceiverInfo message (RI) handling",
        username: "Username",
        password: "Password",
        login: "Log in",
        info1: "Browse RI messages",
        info2: "Remove RI messages",
        info3: "Edit invoicee information",
        wrongPass: "Wrong username or password",
        serviceDown: "Service is unavailable Contact servicedesk@apixmessaging.fi.",
        accountLocked: "For security reasons, the account will be locked after five (5) invalid attempts have been made to log in to the service. Your account is locked for 5 minutes"

    },
    modal: {
        confirm: "OK",
        cancel: "Cancel",
        confirmSendLetter: "Do you wish to send out {count} notification?",
        confirmSending: "Confirm sending",
        remove: "Confirm remove",
        stop: "Stop"
    },
    letters: {
        select: "Select letter",
        name: "Name",
        remove: "Delete",
        update: "Save",
        createNew: "Create new",
        create: "Create",
        downloadPDF: "Download PDF",
        preview: "Preview",
        updated: "Saved",
        subject: "Subject",
        errorUpdating: "Error in updating",
        exampleSentSuccesful: "Test sent",
        errorSendingExample: "Error in sending test",
        errorAdding: "Error adding letter",
        errorRemoving: "Error removing letter",
        removeSuccessful: "Delete succesful",
        addSuccessful: "Letter created",
        sendTest: "Send test email",
        confirmRemove: "Do you wish to remove letter {name}?",
        confirmTest: "Send test email to {email}?",
        userAddressMissing: "Address is missing from user. Update user address from Laskumappi Tools."

    },
    b2c: {
        selectedInvoicer: "Invoicer",
        selectInvoicer: "-- Select invoicer --",
        selectAll: "All",
        notFound: "Invoicee not found",
        delete: "Delete selected messages:",
        save: "Save",
        title: "RI-messages",
        invoicee: "Invoicee",
        name: "Name",
        address1: "Address 1",
        address2: "Address 2",
        businessId: "Business ID",
        city: "City",
        createdAt: "Created at",
        updatedAt: "Updated at",
        hash: "Hash",
        apixId: "ApixID",
        postCode: "Postcode",
        ibanAddress: "IBAN",
        ibanBic: "BIC",
        serviceCode: "Service code",
        country: "Country",
        email: "Email",
        errorUpdating: "Saving failed",
        errorRemoving: "Delete failed",
        removeSuccessful: "Messages deleted: {count}",
        language: "Language",
        invoices: "{count} message ::: {count} messages",
        confirmRemove: "Do you wish to remove {count} messages?",

        texts: {
            count: "Showing {from}-{to} of results|{count} results|One result",
            filter: "Filter:",
            filterPlaceholder: "Search",
            limit: "Pagesize:",
            page: "Page:",
            noResults: "No results",
            filterBy: "Search by {column}",
            loading: "Searching...",
            defaultOption: "Select {column}",
            columns: "Columns"
        },
        statusTexts: {
            "active": "E-invoices received from supplier",
            "new": "No e-invoices received from supplier",
            "pending": "Supplier has been informed, awaiting e-invoices",
            "error": "Print invoices received after informing"
        }
    },
}